'use client';

import { useEffect } from 'react';
import { notifyError } from '@/lib/bugsnag';

// Catches errors thrown in the root layout / above the in-tree error boundary.
export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    notifyError(error, { where: 'global-error', digest: error.digest });
  }, [error]);

  return (
    <html lang="en">
      <body style={{ padding: 24, fontFamily: 'system-ui, sans-serif' }}>
        <h2>Something went wrong</h2>
        <button onClick={() => reset()}>Try again</button>
      </body>
    </html>
  );
}
